import React from "react";
import logo from "../assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { useEffect } from "react";
import { auth } from "../firebase";
// testing if locked

export const Landing = () => {
  const navigate = useNavigate();

  // Auth user
  useEffect(() => {
    const listen = onAuthStateChanged(auth, (user) => {
      if (user) {
        navigate("/dashboard", { replace: true });
      }
    });
    return () => {
      listen();
    };
  }, []);

  // In your Signup component
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const refCode = queryParams.get("ref");

    if (refCode) {
      // Pre-fill the referral code field
      setReferralCode(refCode);

      // Check if this is a valid referral code
      checkReferralCode(refCode);
    }
  }, []);

  const checkReferralCode = async (code) => {
    try {
      const response = await fetch(`/api/validate-referral?code=${code}`);
      const data = await response.json();

      if (data.valid) {
        toast.success("Referral code applied successfully!");
        // You might want to apply a discount or other benefits here
      } else {
        toast.error("Invalid referral code");
      }
    } catch (error) {
      console.error("Error validating referral code:", error);
    }
  };

  return (
    <>
      <div className="all-center">
        <img src={logo} className="app-logo" alt="logo" />
        <div className="box">
          {/* <button className="btn btn-signup btn-primary m-2">
            <Link to="/auth/signup">Sign Up</Link>
          </button> */}
          <button className="btn btn-login btn-primary m-2">
            <Link to="/auth/signin">Sign In</Link>
          </button>
          <button className="btn btn-signup btn-primary m-2">
            <Link to="/signup">Sign Up</Link>
          </button>
        </div>
        {/* <div id="coursesRedirect" className="form-text mt-3">
          Access free courses <Link to="course">Here</Link>{" "}
        </div> */}
      </div>
    </>
  );
};
